var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightArrowIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#272C36",
    fillOpacity: 0.64
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9101 30.67C18.7201 30.67 18.5301 30.6 18.3801 30.45C18.0901 30.16 18.0901 29.68 18.3801 29.39L24.9001 22.87C25.3801 22.39 25.3801 21.61 24.9001 21.13L18.3801 14.61C18.0901 14.32 18.0901 13.84 18.3801 13.55C18.6701 13.26 19.1501 13.26 19.4401 13.55L25.9601 20.07C26.4701 20.58 26.7601 21.27 26.7601 22C26.7601 22.73 26.4801 23.42 25.9601 23.93L19.4401 30.45C19.2901 30.59 19.1001 30.67 18.9101 30.67Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowIcon);
export default __webpack_public_path__ + "static/media/right-arrow-icon.2667fb9c5aa7443359ecf95fc08e6a4c.svg";
export { ForwardRef as ReactComponent };